import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ICON_TYPE } from "@spartacus/storefront";
import { CheckoutStepType } from '@spartacus/checkout/base/root';
import { CheckoutStepService } from '@spartacus/checkout/base/components';
import { Product, WindowRef } from '@spartacus/core';
import { GenSubscriptionInformationItem } from 'src/app/generac/models/checkout.model';
import { GenServiceProductType } from 'src/app/generac/enums/service-product-type';

@Component({
  selector: 'gen-subscriptions-table',
  templateUrl: './subscriptions-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GenSubscriptionsTableComponent {
  @Input() subscriptionInfo: GenSubscriptionInformationItem[];
  @Input() product: Product;

  isOrderConfirmation: boolean;
  checkoutStepTypeSubscriptionInformation = CheckoutStepType.SUBSCRIPTION_INFORMATION;

  protected readonly ICON_TYPE = ICON_TYPE;

  constructor(
    protected checkoutStepService: CheckoutStepService,
    protected winRef: WindowRef,
  ) {
    this.isOrderConfirmation = this.winRef.location.href.includes('order-confirmation');
  }

  isApiRenewalSubscription(subscription: GenSubscriptionInformationItem): boolean {
    return subscription.type === GenServiceProductType.API_RENEWAL;
  }

  getCheckoutStepUrl(stepType: CheckoutStepType | string): string | undefined {
    const step = this.checkoutStepService.getCheckoutStep(
      stepType as CheckoutStepType
    );
    return step?.routeName;
  }
}
